<div class="divider-container">
	<div class="divider-line"></div>
	<div class="divider-text">
		<ng-content></ng-content>
	</div>
	<div class="divider-line"></div>
</div>
